<template>
  <svg
    :class="computedClass"
    :width="size"
    :height="size"
    viewBox="0 0 36 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M31.7708 17.6488C30.2867 16.3194 28.4159 15.4965 26.4345 15.2907C24.4531 15.085 22.4559 15.5123 20.735 16.5093M25.4714 12.8694C28.7395 12.8694 31.3919 10.2106 31.3919 6.9347C31.3919 3.65874 28.7395 1 25.4714 1C22.2033 1 19.5509 3.65874 19.5509 6.9347C19.5509 10.2106 22.2033 12.8694 25.4714 12.8694ZM10.4728 12.8694C13.7409 12.8694 16.3933 10.2106 16.3933 6.9347C16.3933 3.65874 13.7409 1 10.4728 1C7.20468 1 4.5523 3.65874 4.5523 6.9347C4.5523 10.2106 7.20468 12.8694 10.4728 12.8694ZM1 24.7388C1 22.2225 1.99463 19.809 3.77078 18.0207C5.54693 16.2403 7.95462 15.2433 10.4728 15.2433C12.991 15.2433 15.3908 16.2403 17.1748 18.0207C18.951 19.8011 19.9456 22.2146 19.9456 24.7388H1Z"
      :stroke="color"
      stroke-width="2"
      stroke-miterlimit="10"
    />
    <g clip-path="url(#clip0_701_23175)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M21.9531 22.9004H35.725V32.9998H21.9531V22.9004Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M21.9531 22.9004H26.543V32.9998H21.9531V22.9004Z"
        fill="#002654"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M31.1328 22.9004H35.7227V32.9998H31.1328V22.9004Z"
        fill="#CE1126"
      />
    </g>
    <defs>
      <clipPath id="clip0_701_23175">
        <rect
          width="13.7719"
          height="10.0994"
          fill="white"
          transform="translate(21.9531 22.9004)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface Props {
  size?: number | string;
  color?: string;
  class?: string;
}

const props = withDefaults(defineProps<Props>(), {
  size: 64,
  color: "currentColor",
  class: "",
});

const computedClass = computed(() => props.class);
</script>
